import { ContextMenu, Option } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import React from 'react';
import { SCHEDULE_OTHER_STATUS, SCHEDULE_STATUS, WaitingListStatus } from './card-util';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
const SCHEDULE_TYPE = {
    CHEMOTHERAPY: 'Q',
    CONSULTATION: 'C',
    EXAM: 'E',
    REQUEST: 'R',
    SERVICE: 'S',
    SURGERY: 'Y',
};
const EXPRESSIONS = {
    CANCEL: 'patient.cancel',
    CONFIRM: 'patient.button.confirm',
    RESCHEDULE: 'patient.reschedule',
    RESCHEDULE_MORE: 'patient.reschedule-more-items'
};
const POSSIBLE_CARDS = {
    APPOINTMENT_DASHBOARD_CARD: 'appointment-dashboard-card',
    CARD_APPOINTMENT: 'card-appointment-0'
};
export class AppointmentCardUtils {
    static getCardAction(appointmentCardUtils) {
        const { alias, ieStatus, ieScheduleType, ieStatusListaEspera, statusWaitingList, scheduleTypeOrigin } = appointmentCardUtils;
        const waiting = alias === POSSIBLE_CARDS.CARD_APPOINTMENT ? ieStatusListaEspera : statusWaitingList;
        const isCancelEnable = this.isEnableCancelAction(ieStatus, ieScheduleType, waiting);
        const isConfirmEnable = this.isEnableConfirmAction(ieStatus, ieScheduleType, waiting);
        const isRescheduleEnable = this.isEnableRescheduleAction(appointmentCardUtils, ieStatus, ieScheduleType, scheduleTypeOrigin);
        if (!isCancelEnable && !isRescheduleEnable && !isConfirmEnable) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(ContextMenu, { uuid: generateUUID() }, this.renderAction(isCancelEnable, isConfirmEnable, isRescheduleEnable, appointmentCardUtils)));
    }
    static renderAction(isCancelEnable, isConfirmEnable, isRescheduleEnable, appointmentCardUtils) {
        const elements = [];
        if (isCancelEnable) {
            elements.push(React.createElement(Option, { value: MessageService.translate(EXPRESSIONS.CANCEL), onClick: () => this.handleClickButtonAppintmentCancel(appointmentCardUtils) }));
        }
        if (isConfirmEnable) {
            elements.push(React.createElement(Option, { value: MessageService.translate(EXPRESSIONS.CONFIRM), onClick: () => this.handleClickButtonAppintmentConfirm(appointmentCardUtils) }));
        }
        if (isRescheduleEnable) {
            elements.push(React.createElement(Option, { value: MessageService.translate(EXPRESSIONS.RESCHEDULE), onClick: () => this.handleClickButtonReSchedule(appointmentCardUtils) }));
            elements.push(React.createElement(Option, { value: MessageService.translate(EXPRESSIONS.RESCHEDULE_MORE), onClick: () => this.handleClickButtonReScheduleMore(appointmentCardUtils) }));
        }
        return elements;
    }
    static handleClickButtonReSchedule(appointmentCardUtils) {
        const { onAppointmentReschedule, nrSequencia, ieScheduleType } = appointmentCardUtils;
        if (isFunction(onAppointmentReschedule)) {
            onAppointmentReschedule(nrSequencia, ieScheduleType);
        }
    }
    static handleClickButtonReScheduleMore(appointmentCardUtils) {
        const { onAppointmentRescheduleMore } = appointmentCardUtils;
        if (isFunction(onAppointmentRescheduleMore)) {
            onAppointmentRescheduleMore();
        }
    }
    static handleClickButtonAppintmentCancel(appointmentCardUtils) {
        const { onAppointmentCancel, patientId, nrSequencia, ieScheduleType, ieStatus } = appointmentCardUtils;
        if (isFunction(onAppointmentCancel)) {
            onAppointmentCancel(patientId, ieScheduleType, ieStatus, nrSequencia);
        }
    }
    static handleClickButtonAppintmentConfirm(appointmentCardUtils) {
        const { onAppointmentConfirm, patientId, scheduleCode, nrSequencia, ieScheduleType } = appointmentCardUtils;
        if (isFunction(onAppointmentConfirm)) {
            onAppointmentConfirm(patientId, ieScheduleType, scheduleCode, nrSequencia);
        }
    }
    static isEnableCancelAction(status, scheduleType, statusWaitingList) {
        if (statusWaitingList) {
            return statusWaitingList !== WaitingListStatus.CANCELLED;
        }
        const notAllowedScheduleStatus = [
            SCHEDULE_STATUS.CANCELED,
            SCHEDULE_STATUS.MISSED,
            SCHEDULE_OTHER_STATUS.CANCELED,
            SCHEDULE_OTHER_STATUS.EXECUTION
        ];
        const allowedScheduleType = [
            SCHEDULE_TYPE.CONSULTATION,
            SCHEDULE_TYPE.REQUEST,
            SCHEDULE_TYPE.EXAM,
            SCHEDULE_TYPE.SERVICE
        ];
        return !notAllowedScheduleStatus.includes(status) && allowedScheduleType.includes(scheduleType);
    }
    static isEnableConfirmAction(status, scheduleType, statusWaitingList) {
        if (statusWaitingList) {
            return statusWaitingList !== WaitingListStatus.CANCELLED;
        }
        const notAllowedScheduleStatus = [
            SCHEDULE_STATUS.CANCELED,
            SCHEDULE_STATUS.MISSED,
            SCHEDULE_STATUS.CONFIRMED,
            SCHEDULE_OTHER_STATUS.CANCELED,
            SCHEDULE_OTHER_STATUS.EXECUTION
        ];
        const allowedScheduleType = [
            SCHEDULE_TYPE.CONSULTATION,
            SCHEDULE_TYPE.EXAM,
            SCHEDULE_TYPE.SERVICE
        ];
        return !notAllowedScheduleStatus.includes(status) && allowedScheduleType.includes(scheduleType);
    }
    static isEnableRescheduleAction(appointmentCardUtils, status, scheduleType, scheduleTypeOrigin) {
        const statusEnableReschedule = 'S';
        const { rescheduleConsultation, rescheduleExam, rescheduleService } = appointmentCardUtils;
        if (scheduleType === SCHEDULE_TYPE.REQUEST) {
            scheduleType = scheduleTypeOrigin || '';
        }
        if (scheduleType === SCHEDULE_TYPE.CONSULTATION && rescheduleConsultation !== statusEnableReschedule) {
            return false;
        }
        if (scheduleType === SCHEDULE_TYPE.EXAM && rescheduleExam !== statusEnableReschedule) {
            return false;
        }
        if (scheduleType === SCHEDULE_TYPE.SERVICE && rescheduleService !== statusEnableReschedule) {
            return false;
        }
        const allowedScheduleStatus = [
            SCHEDULE_OTHER_STATUS.EXECUTION,
            SCHEDULE_STATUS.AWAITING_APPROVAL,
            SCHEDULE_STATUS.NOT_APPROVED,
            SCHEDULE_STATUS.CONFIRMED,
            SCHEDULE_STATUS.APPROVED
        ];
        const allowedScheduleType = [
            SCHEDULE_TYPE.CONSULTATION,
            SCHEDULE_TYPE.EXAM,
            SCHEDULE_TYPE.SERVICE
        ];
        return allowedScheduleStatus.includes(status) && allowedScheduleType.includes(scheduleType);
    }
}
//# sourceMappingURL=appointment-card-utils.js.map